/* TwoUpGrip theme JS (vanilla, no deps) */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (cents) {
    var f = (window.TUG && window.TUG.moneyFormat) || '${{amount}}';
    var n = (cents / 100);
    var out = f.replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(n).toLocaleString('de-DE'))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(n).toLocaleString('en-US'))
      .replace(/\{\{\s*amount\s*\}\}/, n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
    return out.replace(/<[^>]+>/g, '');
  };
  var toast = function (msg) {
    var t = $('[data-toast]'); if (!t) return;
    t.textContent = msg; t.setAttribute('data-show', 'true');
    clearTimeout(t._h); t._h = setTimeout(function () { t.removeAttribute('data-show'); }, 2200);
  };

  /* ---------- Header menu ---------- */
  var burger = $('[data-menu-toggle]'), menu = $('[data-menu]');
  if (burger && menu) burger.addEventListener('click', function () {
    var open = menu.getAttribute('data-open') === 'true';
    menu.setAttribute('data-open', open ? 'false' : 'true'); burger.setAttribute('aria-expanded', String(!open));
  });
  document.addEventListener('click', function (e) {
    if (menu && burger && !menu.contains(e.target) && !burger.contains(e.target)) { menu.setAttribute('data-open', 'false'); burger.setAttribute('aria-expanded', 'false'); }
  });

  /* ---------- Countdown (persists in localStorage, like a flash offer) ---------- */
  var cd = $('[data-countdown]');
  if (cd) {
    var hours = parseInt(cd.getAttribute('data-hours') || '3', 10), dur = hours * 3600 * 1000, key = 'tug_offer_start', out = $('[data-countdown-time]', cd);
    var start = parseInt(localStorage.getItem(key) || '0', 10); if (!start) { start = Date.now(); try { localStorage.setItem(key, String(start)); } catch (e) {} }
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var rem = start + dur - Date.now();
      if (rem <= 0) { start = Date.now(); try { localStorage.setItem(key, String(start)); } catch (e) {} rem = dur; }
      var s = Math.floor(rem / 1000), h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      out.textContent = pad(h) + 'h ' + pad(m) + 'm ' + pad(sec) + 's';
    };
    tick(); setInterval(tick, 1000);
  }

  /* ---------- Generic scroll-snap slider helper (scrolls only inside its own track, never the page) ---------- */
  function slider(track, dots, thumbs, prev, next) {
    if (!track) return null;
    var slides = Array.prototype.slice.call(track.children), idx = 0;
    var dotEls = dots ? $$('[data-goto]', dots) : [], thumbEls = thumbs ? $$('[data-goto]', thumbs) : [];
    var mark = function () {
      dotEls.forEach(function (d, i) { d.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
      thumbEls.forEach(function (d, i) { d.setAttribute('aria-current', i === idx ? 'true' : 'false'); if (i === idx && thumbs) thumbs.scrollTo({ left: d.offsetLeft - thumbs.offsetLeft - (thumbs.clientWidth - d.clientWidth) / 2, behavior: 'smooth' }); });
    };
    var go = function (i) { idx = (i + slides.length) % slides.length; track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: 'smooth' }); mark(); };
    dotEls.concat(thumbEls).forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-goto'), 10)); }); });
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    var t; track.addEventListener('scroll', function () {
      clearTimeout(t); t = setTimeout(function () {
        var l = track.scrollLeft, best = 0, bd = 1e9;
        slides.forEach(function (s, i) { var d = Math.abs(s.offsetLeft - track.offsetLeft - l); if (d < bd) { bd = d; best = i; } });
        idx = best; mark();
      }, 80);
    }, { passive: true });
    return { go: go };
  }
  var gal = $('[data-gallery]');
  if (gal) slider($('[data-gallery-track]', gal), $('[data-gallery-dots]', gal), $('[data-gallery-thumbs]', gal), $('[data-gallery-prev]', gal), $('[data-gallery-next]', gal));
  var q = $('[data-quotes]'); if (q) { var qs = slider($('[data-quotes-track]', q), $('[data-quotes-dots]', q)); if (qs) { var qi = 0, qVisible = false; if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { qVisible = en[0].isIntersecting; }, { threshold: .9 }).observe(q); setInterval(function () { if (document.hidden || !qVisible) return; qi = (qi + 1) % $$('.tug-quote', q).length; qs.go(qi); }, 6000); } }
  var ugc = $('[data-ugc-track]'); if (ugc) slider(ugc, $('[data-ugc-dots]'));
  $$('[data-ugc-mute]').forEach(function (b) {
    b.addEventListener('click', function () {
      var v = b.parentNode.querySelector('video'); if (!v) return; v.muted = !v.muted; if (!v.muted) v.play();
      b.style.opacity = v.muted ? '1' : '.7';
    });
  });

  /* ---------- Variants / price ---------- */
  var sec = $('[data-product-section]');
  var variants = [];
  try { variants = JSON.parse(($('[data-variants]', sec) || {}).textContent || '[]'); } catch (e) {}
  var form = $('[data-product-form]'), idInput = $('[data-variant-id]');
  var setVariant = function (id) {
    var v = variants.filter(function (x) { return String(x.id) === String(id); })[0]; if (!v) return;
    idInput.value = v.id;
    var price = $('[data-price]'), cmp = $('[data-compare]'), save = $('[data-save]'), sp = $('[data-sticky-price]'), sc = $('[data-sticky-compare]');
    if (price) price.textContent = money(v.price);
    if (sp) sp.textContent = money(v.price);
    if (v.compare_at_price && v.compare_at_price > v.price) {
      if (cmp) { cmp.textContent = money(v.compare_at_price); cmp.hidden = false; }
      if (save) { save.textContent = 'SAVE ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; save.hidden = false; }
      if (sc) sc.textContent = money(v.compare_at_price);
    } else { if (cmp) cmp.hidden = true; if (save) save.hidden = true; if (sc) sc.textContent = ''; }
    var atc = $('[data-atc]'), txt = $('[data-atc-text]');
    if (atc) { atc.disabled = !v.available; if (txt) txt.textContent = v.available ? (atc.getAttribute('data-label') || txt.getAttribute('data-default') || txt.textContent) : 'Sold out'; }
  };
  $$('input[name="tug-variant"]').forEach(function (r) { r.addEventListener('change', function () { setVariant(r.value); }); });
  var txt0 = $('[data-atc-text]'); if (txt0) txt0.setAttribute('data-default', txt0.textContent);

  /* ---------- Cart drawer ---------- */
  var drawer = $('[data-cart-drawer]'), cartState = null;
  var openCart = function () { document.body.setAttribute('data-cart-open', 'true'); startReserve(); refreshCart(); };
  var closeCart = function () { document.body.removeAttribute('data-cart-open'); };
  $$('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openCart(); }); });
  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
  var reserveT = null;
  function startReserve() {
    var el = $('[data-cart-timer]'); if (!el || reserveT) return;
    var end = Date.now() + 5 * 60 * 1000;
    reserveT = setInterval(function () {
      var r = Math.max(0, end - Date.now()), m = Math.floor(r / 60000), s = Math.floor((r % 60000) / 1000);
      el.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      if (r <= 0) { clearInterval(reserveT); reserveT = null; }
    }, 1000);
  }
  var protectEl = $('[data-protect]'), protectId = protectEl ? protectEl.getAttribute('data-variant') : null;
  var giftId = sec ? sec.getAttribute('data-gift-variant') : null, giftThreshold = sec ? parseInt(sec.getAttribute('data-gift-threshold') || '0', 10) : 0;
  function cartFetch(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
  }
  function renderCart(c) {
    cartState = c;
    var list = $('[data-cart-items]'), cnt = $('[data-cart-count]'), hc = $('[data-cart-head-count]'), pl = $('[data-cart-plural]'), sub = $('[data-cart-subtotal]');
    var visible = c.items.filter(function (it) { return String(it.variant_id) !== String(giftId); });
    var count = visible.reduce(function (a, it) { return a + it.quantity; }, 0);
    if (cnt) { cnt.textContent = count; cnt.setAttribute('data-count', count); }
    if (hc) hc.textContent = count; if (pl) pl.textContent = count === 1 ? '' : 's';
    if (sub) sub.textContent = money(c.total_price);
    if (list) {
      if (!c.items.length) list.innerHTML = '<div class="tug-cd__empty">Your cart is empty.</div>';
      else list.innerHTML = c.items.map(function (it) {
        var isP = String(it.variant_id) === String(protectId), isG = String(it.variant_id) === String(giftId);
        return '<div class="tug-cd-item" data-key="' + it.key + '">' +
          '<img src="' + (it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, '_200x$1$2') : '') + '" alt="">' +
          '<div><div class="tug-cd-item__t">' + it.product_title + '</div>' + (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="tug-cd-item__v">' + it.variant_title + ' Kit</div>' : '') +
          (isP || isG ? '' : '<div class="tug-qty"><button type="button" data-qty="-1" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button type="button" data-qty="1" aria-label="Increase">+</button></div>') + '</div>' +
          '<div class="tug-cd-item__p">' + (isG ? 'FREE' : money(it.final_line_price)) + (isG ? '' : '<button class="tug-cd-item__rm" type="button" data-remove>Remove</button>') + '</div></div>';
      }).join('');
    }
    var sw = $('[data-protect-toggle]'); if (sw) sw.setAttribute('aria-checked', c.items.some(function (it) { return String(it.variant_id) === String(protectId); }) ? 'true' : 'false');
    updateGift(c);
  }
  function refreshCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(renderCart); }
  function changeLine(key, qty) { return cartFetch('/cart/change.js', { id: key, quantity: qty }).then(renderCart); }
  if (drawer) drawer.addEventListener('click', function (e) {
    var qb = e.target.closest('[data-qty]'), rm = e.target.closest('[data-remove]'), row = e.target.closest('[data-key]');
    if (!row) return;
    var it = cartState && cartState.items.filter(function (x) { return x.key === row.getAttribute('data-key'); })[0]; if (!it) return;
    if (qb) changeLine(it.key, it.quantity + parseInt(qb.getAttribute('data-qty'), 10));
    if (rm) changeLine(it.key, 0);
  });
  var sw = $('[data-protect-toggle]');
  if (sw && protectId) sw.addEventListener('click', function () {
    var on = sw.getAttribute('aria-checked') === 'true';
    if (on) { var it = cartState && cartState.items.filter(function (x) { return String(x.variant_id) === String(protectId); })[0]; if (it) changeLine(it.key, 0); }
    else cartFetch('/cart/add.js', { items: [{ id: parseInt(protectId, 10), quantity: 1 }] }).then(refreshCart);
  });
  var giftBusy = false;
  function updateGift(c) {
    var box = $('[data-gift]'); if (!box) return;
    var always = box.getAttribute('data-gift-mode') === 'always'; if (!always && !giftThreshold) return;
    var paid = c.items.filter(function (it) { return String(it.variant_id) !== String(giftId) && String(it.variant_id) !== String(protectId); }).reduce(function (a, it) { return a + it.final_line_price; }, 0);
    var left = always ? (paid > 0 ? 0 : 1) : Math.max(0, giftThreshold - paid);
    if (!always) {
      var pct = Math.min(100, Math.round(paid * 100 / giftThreshold)), fill = $('[data-gift-fill]', box); if (fill) fill.style.width = pct + '%';
      var title = $('[data-gift-title]', box), tile = $('[data-gift-tile]', box), state = $('[data-gift-state]', box);
      var name = tile ? tile.lastElementChild.textContent : 'your gift';
      if (left > 0) { title.innerHTML = 'Add <span data-gift-left>' + money(left) + '</span> to get ' + name + ' for free 📢'; tile.setAttribute('data-unlocked', 'false'); state.textContent = 'Locked'; }
      else { title.textContent = '🎉 ' + name + ' unlocked – it\'s free in your cart!'; tile.setAttribute('data-unlocked', 'true'); state.textContent = 'Unlocked'; }
    }
    var has = c.items.some(function (it) { return String(it.variant_id) === String(giftId); });
    if (!giftId || giftBusy) return;
    if (left <= 0 && !has) { giftBusy = true; cartFetch('/cart/add.js', { items: [{ id: parseInt(giftId, 10), quantity: 1 }] }).then(refreshCart).finally(function () { giftBusy = false; }); }
    if (left > 0 && has) { var g = c.items.filter(function (it) { return String(it.variant_id) === String(giftId); })[0]; giftBusy = true; changeLine(g.key, 0).finally(function () { giftBusy = false; }); }
  }
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    var atc = $('[data-atc]', form), t = $('[data-atc-text]', form), old = t.textContent; atc.disabled = true; t.textContent = 'Adding…';
    cartFetch('/cart/add.js', { items: [{ id: parseInt(idInput.value, 10), quantity: 1 }] }).then(function (r) {
      if (r.status && r.status !== 200) { toast(r.description || 'Could not add to cart'); return; }
      return refreshCart().then(openCart);
    }).catch(function () { toast('Network error, please retry.'); }).finally(function () { atc.disabled = false; t.textContent = old; });
  });
  var stickyBtn = $('[data-sticky-atc]'); if (stickyBtn && form) stickyBtn.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })); });
  refreshCart();

  /* ---------- Sticky bar ---------- */
  var sticky = $('[data-sticky]'), atcBtn = $('[data-atc]');
  if (sticky && atcBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { var r = en[0]; sticky.setAttribute('data-show', (!r.isIntersecting && r.boundingClientRect.top < 0) ? 'true' : 'false'); }, { threshold: 0 }).observe(atcBtn);
  }

  /* ---------- Compare slider ---------- */
  var cmp = $('[data-cmp]');
  if (cmp) {
    var range = $('[data-cmp-range]', cmp), after = $('.tug-cmp__after', cmp), handle = $('[data-cmp-handle]', cmp), knob = $('[data-cmp-knob]', cmp);
    var set = function (v) { after.style.clipPath = 'inset(0 0 0 ' + v + '%)'; handle.style.left = v + '%'; knob.style.left = v + '%'; };
    range.addEventListener('input', function () { set(range.value); }); set(50);
    var vids = $$('video', cmp); vids.forEach(function (v) { v.addEventListener('loadedmetadata', function () { v.play().catch(function () {}); }); });
  }

  /* ---------- Reviews show more ---------- */
  var more = $('[data-reviews-more]');
  if (more) more.addEventListener('click', function () {
    var hidden = $$('.tug-review[hidden]'); hidden.slice(0, 12).forEach(function (r) { r.hidden = false; });
    if ($$('.tug-review[hidden]').length === 0) more.hidden = true;
  });

  /* ---------- Lazy play videos when visible ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { var v = e.target; if (e.isIntersecting) v.play().catch(function () {}); else v.pause(); }); }, { threshold: .2 });
    $$('video[autoplay]').forEach(function (v) { io.observe(v); });
  }
})();
